import { useEffect, useRef } from 'react'


function Base( props )
{
    const cssFile = props.cssFile 
    const jsFile = props.jsFile

    const jsInit = props.jsInit
    const jsDestruct = props.jsDestruct

    const jsInstance = useRef(null)

    useEffect(() => {
        const script = document.createElement('script');
        script.src = jsFile;
        script.async = true;

        script.onload = () => {
            if( jsInit && jsInstance.current == null )
            {
                jsInstance.current = jsInit()
            }

        }

        document.body.appendChild(script);

        return () => {
            if( jsFile && jsInstance.current && script )
            {
                delete jsDestruct.current;
                jsInstance.current = null;

                if( jsDestruct )
                {
                    jsDestruct();
                }
            }

            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []); // Runs once on mount

    return (
        <div className="external-scope" style={{ height:'100%', width:'100%'}}>
                <link rel="stylesheet" href={cssFile} precedence="default" />
                { props.children } 
        </div>
    )
}

export function KingmakerRngKing( props )
{
    const jsInit = () => {
        const items = ["Pizza", "Sushi", "Tacos", "Burger", "Salad", "Steak", "Pasta", "Ramen"];
        const selector = new window.RandomSelector('selector-container', items)
        selector.start()

        return selector
    }

    const jsDestruct = () => {
        if( window.RandomSelector )
        {
            delete window.RandomSelector
        }
    }

    return (
            <Base cssFile="/css/RandomSelector.css"
                  jsFile="/js/RandomSelector.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                <div id="selector-container">Ready?</div>
            </Base>
    )
}

export function KingmakerBossSlayer( props )
{
    const jsInit = () => {
        const game = new window.BossSlayer('my-layer-id')
        return game
    }

    const jsDestruct = () => {
        if( window.BossSlayer )
        {
            delete window.BossSlayer
        }
    }

    return (
            <Base cssFile="/css/BossSlayer.css"
                  jsFile="/js/BossSlayer.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                
                <div className="boss-slayer-widget-container">
                    <svg className="boss-slayer-svg" viewBox="0 0 100 100" id="gameSvg">
                        <g id="shakeWrapper" style={{transformOrigin: 'center'}}>
                            <g id="bossGroup" className="boss-slayer-group">
                                <circle cx="50" cy="50" r="40" fill="url(#bossGradient)" stroke="none" />
                                <circle cx="50" cy="50" r="40" className="boss-slayer-ring-track" />
                                <circle cx="50" cy="50" r="40" className="boss-slayer-ring-progress" id="ringProgress" />
                                <text x="50" y="50" text-anchor="middle" className="boss-slayer-emoji">👹</text> 
                                <text x="50" y="80" className="boss-slayer-hp-text" id="hpText"></text>
                            </g>
                        </g>
                    </svg>
                </div>
            </Base>
    )
}

export function KingmakerAuctionHouse( props )
{
    const jsInit = () => {

        const myAuction = new window.AuctionHouse(
            'my-layer-id',
            {
                duration: 300, // 300 seconds
                displayDuration: 1500 // 1.5 seconds per message
            }
        );
        return myAuction
    }

    const jsDestruct = () => {
        if( window.AuctionHouse )
        {
            delete window.AuctionHouse
        }
    }

    return (
            <Base cssFile="/css/AuctionHouse.css"
                  jsFile="/js/AuctionHouse.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
            
                <div className="auction-house-widget-container" id="widget">
                    <div className="auction-house-header-section">
                        <div className="auction-house-king-info">
                            <div className="auction-house-crown-icon">👑</div>
                            <div className="auction-house-highest-bid-data">
                                <span className="auction-house-label">Current King</span>
                                <span className="auction-house-current-king-name" id="kingName">No King Yet</span>
                            </div>
                        </div>
                        <div className="auction-house-highest-bid-data" style={{ textAlign: 'right' }}>
                            <span className="auction-house-label">Top Bid</span>
                            <span className="auction-house-current-amount" id="topBid">0</span>
                        </div>
                    </div>

                    <div className="auction-house-progress-wrapper">
                        <div className="auction-house-progress-fill" id="progressBar"></div>
                    </div>

                    <div className="auction-house-feed-section" id="feedSection">
                        <div className="auction-house-feed-content-wrapper" id="feedContent">
                            <span className="auction-house-status-indicator" id="feedStatus"></span>
                            <span className="auction-house-feed-text" id="feedText">Waiting for bids...</span>
                        </div>
                    </div>
                </div>
        </Base>
    )
}

export function KingmakerKingOfTheHill( props )
{
    const jsInit = () => {
        const game = new window.KingOfTheHill('my-layer-id', 300, 5);
        return game
    }

    const jsDestruct = () => {
        if( window.AuctionHouse )
        {
            delete window.AuctionHouse
        }
    }

    return (
            <Base cssFile="/css/KingOfTheHill.css"
                  jsFile="/js/KingOfTheHill.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
            
                <div id="king-of-the-hill-widget-container">
                    <div id="king-of-the-hill-timer-badge"></div>
                    <div id="king-of-the-hill-throne-area">
                        <div id="king-of-the-hill-label-king">Current Ruler</div>
                        <div id="king-of-the-hill-current-king-name">NO KING</div>

                        <div id="king-of-the-hill-cooldown-container">
                            <div id="king-of-the-hill-cooldown-bar"></div>
                        </div>

                        <div id="king-of-the-hill-status-text">Waiting to start...</div>
                    </div>

                    <div id="king-of-the-hill-global-timer-container">
                        <div id="king-of-the-hill-global-progress-bar"></div>
                    </div>
                </div>
            </Base>
    )
}

export function KingmakerTournament( props )
{
    const jsInit = () => {
        const tournament = new window.Tournament('my-layer-id');
        return tournament
    }

    const jsDestruct = () => {
        if( window.Tournament )
        {
            delete window.Tournament
        }
    }

    return (
            <Base cssFile="/css/Tournament.css"
                  jsFile="/js/Tournament.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
            
                <div id="tournament-widget-container">
                    <div id="tournament-arena">
                        <div className="tournament-player-box">
                            <div className="tournament-player-label">Player 1</div>
                            <div className="tournament-player-name" id="tournament-p1-name">Waiting...</div>
                        </div>

                        <div id="tournament-center-display" className="tournament-state-vs">
                            <div id="tournament-center-circle"></div>
                            <div id="tournament-center-text">VS</div>
                        </div>

                        <div className="tournament-player-box">
                            <div className="tournament-player-label">Player 2</div>
                            <div className="tournament-player-name" id="tournament-p2-name">Waiting...</div>
                        </div>
                    </div>

                    <div id="tournament-timer-container">
                        <div id="tournament-timer-bar"></div>
                    </div>

                    <div id="tournament-winner-overlay">
                        <div style={{ fontSize:'0.9rem',  textTransform:'uppercase', color:'#888'}}>Winner</div>
                        <div id="tournament-winner-name">NAME</div>
                        <div id="tournament-winner-reason">Fastest Reaction</div>
                    </div>
                </div>
            </Base>
    )
}

export function KingmakerQuickdraw( props )
{
    const jsInit = () => {
        const quickdraw = new window.Quickdraw('my-layer-id');
        return quickdraw
    }

    const jsDestruct = () => {
        if( window.Quickdraw )
        {
            delete window.Quickdraw
        }
    }

    return (
            <Base cssFile="/css/Quickdraw.css"
                  jsFile="/js/Quickdraw.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
            
                <div id="quickdraw-widget-container">
                    <div id="quickdraw-arena">
                        <div id="quickdraw-status-text">Waiting...</div>
                        <div id="quickdraw-target-display" className="quickdraw-blurred">???????</div>
                    </div>

                    <div id="quickdraw-round-overlay">
                        <div className="quickdraw-win-title">Draw Winner</div>
                        <div id="quickdraw-round-winner-name">NAME</div>
                    </div>
                </div>
            </Base>
    )
}

export function EchoChambersCanvasWall( props )
{
    const jsInit = () => {

        const wall = new window.CanvasWall('my-layer-id', 'canvasWallView', 5, 5);
        return wall
    }

    const jsDestruct = () => {
        if( window.CanvasWall )
        {
            delete window.CanvasWall
        }
    }

    return (
            <Base cssFile="/css/CanvasWall.css"
                  jsFile="/js/CanvasWall.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                <div className="canvas-wall-wrapper"> 
                <div id="canvasWallView" className="canvas-wall-grid"></div>
                </div>
            </Base>
    )
}

export function EchoChambersCharacterSheet( props )
{
    const jsInit = () => {

        const sheet = new window.CharacterSheet('my-layer-id', {
            containerId: 'character-sheet-stats-list',
            step: 5,
            attributes: [
                { id: 'aim',   name: 'AIM',        val: 85, col: '#00E676' },
                { id: 'iq',    name: 'BRAIN',      val: 60, col: '#2979FF' },
                { id: 'luck',  name: 'LUCK',       val: 30, col: '#D500F9' },
                { id: 'comm',  name: 'COMMS',      val: 50, col: '#FF9100' },
                { id: 'salt',  name: 'SALT',       val: 10, col: '#FF1744' },
                { id: 'focus', name: 'FOCUS',      val: 75, col: '#00E5FF' }, 
            ]
        });

        return sheet
    }

    const jsDestruct = () => {
        if( window.CanvasWall )
        {
            delete window.CanvasWall
        }
    }

    return (
            <Base cssFile="/css/CharacterSheet.css"
                  jsFile="/js/CharacterSheet.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >

                <div className="character-sheet-widget-container">
                    <div id="character-sheet-stats-list"></div>
                </div>
            </Base>
    )
}

export function InfluencerTugOfWar( props )
{
    const jsInit = () => {

        const game = new window.TugOfWar('my-layer-id', {
            steps: 5,
            content: "⚔️",
            containerSelector: "#tug-of-war-game-container",
            markerSelector: "#tug-of-war-marker"
        });

        return game
    }

    const jsDestruct = () => {
        if( window.TugOfWar )
        {
            delete window.TugOfWar
        }
    }

    return (
            <Base cssFile="/css/TugOfWar.css"
                  jsFile="/js/TugOfWar.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >

                <div className="tug-of-war-container" id="tug-of-war-game-container">
                    <div className="tug-of-war-rope"></div>
                    <div className="tug-of-war-center-line"></div>
                    <div className="tug-of-war-marker" id="tug-of-war-marker"></div>
                </div>
            </Base>
    )
}

export function InfluencerTheSelector( props )
{
    const jsInit = () => {

        const selector = new window.VisualSelector('my-layer-id', 'the-selector-widget-container', 
            [
                { 'id': 'standard', 'label': 'Standard', 'icon': '📦' },
                { 'id': 'priority', 'label': 'Priority', 'icon': '🚀' },
                { 'id': 'express', 'label': 'Express', 'icon': '⚡' }
            ], (id) => {
            console.log("Selected Shipping:", id);
        });
        
        return selector
    }

    const jsDestruct = () => {
        if( window.VisualSelector )
        {
            delete window.VisualSelector
        }
    }

    return (
            <Base cssFile="/css/TheSelector.css"
                  jsFile="/js/TheSelector.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                <div id="the-selector-widget-container"></div>
            </Base>
    )
}



export function RngMinimal( props )
{
    const jsInit = () => {
        const items = ["Pizza", "Sushi", "Tacos", "Burger", "Salad", "Steak", "Pasta", "Ramen"];
        const selector = new window.RandomSelector('selector-container', items)
        selector.start()

        return selector
    }

    const jsDestruct = () => {
        if( window.RandomSelector )
        {
            delete window.RandomSelector
        }
    }

    return (
            <Base cssFile="/css/RandomSelector.css"
                  jsFile="/js/RandomSelector.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                <div id="selector-container">Ready?</div>
            </Base>
    )
}

export function RngSlotMachine( props )
{
    return (
            <Base cssFile="/css/SlotMachine.css">
                <div className="slot-machine-window" id="slot-window">
                    <div className="slot-strip" id="slot-strip">
                        <div className="slot-item">
                            Ready?
                        </div>
                    </div>
                    <div className="slot-overlay">
                    </div>
                </div>
            </Base>
    )
}

export function RngWheelOfFortune( props )
{
    const jsInit = () => {
        const items = ["Pizza", "Sushi", "Tacos", "Burger", "Salad", "Steak", "Pasta", "Ramen"];
        const canvas = document.getElementById('wheel');
        return new window.WheelSelector('my-layer-id', canvas, items);
    }

    const jsDestruct = () => {
        if( window.WheelSelector )
        {
            delete window.WheelSelector
        }
    }
    
    return (
            <Base cssFile="/css/WheelOfFortune.css" 
                  jsFile="/js/WheelOfFortune.js"
                  jsInit={jsInit}
                  jsDestruct={jsDestruct}
            >
                <div className="wheel-of-fortune-div">
                    <div className="wheel-container">
                        <div className="wheel-pointer"></div>
                            <canvas id="wheel" width="800" height="800"></canvas>
                        <div className="wheel-center-circle"></div>
                    </div>
                </div>
            </Base>
    )
}

const COMPONENT_MAP = {
    'kingmaker-rng-king': KingmakerRngKing,
    'kingmaker-boss-slayer': KingmakerBossSlayer,
    'kingmaker-auction-house': KingmakerAuctionHouse,
    'kingmaker-king-of-the-hill': KingmakerKingOfTheHill,
    'kingmaker-tournament': KingmakerTournament,
    'kingmaker-quickdraw':KingmakerQuickdraw,
    'echo-chambers-canvas-wall': EchoChambersCanvasWall,
    'echo-chambers-character-sheet': EchoChambersCharacterSheet,
    'influencer-tug-of-war': InfluencerTugOfWar,
    'influencer-the-selector': InfluencerTheSelector,
    'rng-minimal': RngMinimal,
    'rng-slot-machine': RngSlotMachine,
    'rng-wheel-of-fortune': RngWheelOfFortune,
}

export default function Render( props )
{
    const dynoTag = props.dynoTag

    const Component = COMPONENT_MAP[dynoTag]

    if (!Component) return <>{dynoTag}</>;

    return <Component />
}

